<div class="table-root-child">
    <div class="table-action-wrapper">
        <div class="table-action-inner d-flex align-items-center justify-content-between">
        <div class="d-flex">
            <div class="search-input">
                <img src="../../assets/icons/search.svg" alt="Search icon" (click)="search()" />
                <input type="text" [placeholder]="'COMMON.SEARCH' | translate" [(ngModel)]="searchText"
                    (keydown.enter)="search()" (ngModelChange)="this.searchTextUpdate.next($event)" />
            </div>
            <div class="search-type-picker">
                <div class="dropdown search-type-dropdown" #stTrigger (click)="openDropdown(stTrigger)" click-stop-propagation>
                    <span>{{'COMMON.BY' | translate}}:</span>
                    <span>{{ selectedSearchTypeDisplay | translate }}</span>
                    <span class="arrow"><img src="../../assets/icons/gray-arrow-down.svg" alt="Gray arrow down" /></span>
                </div>
                <div class="dropdown-opened" *ngIf="showSelectSearchType" style="position:fixed;z-index:9999" [style.top]="ddPos.top" [style.left]="ddPos.left">
                    <div (click)="selectSearchType(searchType)"
                        *ngFor="let searchType of searchByOptions; let i = index">
                        <div>{{ searchType.translation | translate }}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="ml-auto d-flex pt-3">
            <div>
                <div class="d-flex align-items-center data clickable nav-item download-btn"
                    (click)="download()" click-stop-propagation>
                    <span>{{'COMMON.DOWNLOAD' | translate}}</span>
                </div>
            </div>
        </div>
        </div>
    </div>

    <div class="filter">
        <div class="filter-list">
            {{'COMMON.FILTER' | translate}}

            <app-multi-select-dropdown id="new_service_region_filter" class="multiselect" [clicked]="clicked"
                [items]="hasCimDataIntegration ? geographicalRegions : regions" [label]="'COMMON.BU.PLURAL'" [showMore]="false" [requireApply]="true"
                (shareIndividualCheckedList)="hasCimDataIntegration ? selectGeographicalRegion() : selectRegion()">
            </app-multi-select-dropdown>

            <app-multi-select-dropdown id="new_service_area-filter" class="multiselect" [clicked]="clicked"
                [items]="hasCimDataIntegration ? subGeographicalRegions : areas" [label]="'COMMON.UT.PLURAL'" [showMore]="false" [requireApply]="true"
                (shareIndividualCheckedList)="selectArea()">
            </app-multi-select-dropdown>

            <select [(ngModel)]="selectedSltStatus" (ngModelChange)="selectSltStatus($event)" class="form-select">
                <option [ngValue]="undefined" disabled>{{'NEW_SERVICE.SERVICE_TYPE' | translate}}</option>
                <option [id]="'new_service_service-type-' + (i + 1)" *ngFor="let s of sltOptions; let i = index"
                    [ngValue]="s.id">
                    {{ s.displayValue | translate }}
                </option>
            </select>
            
            <select [(ngModel)]="selectedSubserviceType" (ngModelChange)="selectSubserviceType($event)"
                class="form-select">
                <option [ngValue]="undefined" disabled>{{'NEW_SERVICE.SERVICE_REQUEST_TYPE' | translate}}</option>
                <option [id]="'new_service_service-type-' + (i + 1)"
                    *ngFor="let s of subServiceTypeOptions; let i = index" [ngValue]="s.value">
                    {{ s.displayValue | translate }}
                </option>
            </select>

            <app-multi-select-dropdown id="new_service_project_status_filter" class="multiselect"
                [clicked]="clicked" [items]="projectTypeOptions" [label]="'NEW_SERVICE.PROJECT_STATUS'"
                [showMore]="false" [requireApply]="true" (shareIndividualCheckedList)="selectProjectType()">
            </app-multi-select-dropdown>

            <app-multi-select-dropdown id="new_service_project-designation_filter"
                class="multiselect" [clicked]="clicked" [items]="projectDesignations"
                [label]="'NEW_SERVICE.PROJECT_DESIGNATIONS'" [showMore]="false" [requireApply]="true"
                (shareIndividualCheckedList)="selectProjectDesignation()">
            </app-multi-select-dropdown>

            <select id="srt_tag_filter" name="tag-select" (change)="selectKycTag($event)" class="form-select">
                <option value="" [selected]="!kycTag" disabled>
                    {{ "COMMON.TAG.TITLE" | translate }}
                </option>
                <option [id]="'srt_tag_filter-' + (i + 1)" [selected]="kycTag == t.value"
                    *ngFor="let t of kycTagOptions; let i = index" value="{{ t.value }}">
                    {{ t.translation | translate }}
                </option>
            </select>

            <select [(ngModel)]="selectedApplicationStage"
                (ngModelChange)="selectApplicationStage($event)" class="form-select">
                <option [ngValue]="undefined" disabled>{{'USER_ACTIVITY.APPLICATION_STAGE' | translate}}</option>
                <option [id]="'new_service_application-stage-' + (i + 1)"
                    *ngFor="let s of applicationStageOptions; let i = index" [ngValue]="s.value">
                    {{ s.displayValue | translate }}
                </option>
            </select>

            <app-multi-select-dropdown *ngIf="organizations.length > 0" id="new_service_vendor_filter" class="multiselect" [clicked]="clicked"
                [items]="organizations" [label]="'NEW_SERVICE.ASSIGNED_VENDOR'" [showMore]="false" [requireApply]="true"
                (shareIndividualCheckedList)="selectVendor()">
            </app-multi-select-dropdown>

            <select [(ngModel)]="selectedAssignStatus"
                (ngModelChange)="selectAssignStatus($event)" class="form-select">
                <option [ngValue]="undefined" disabled>{{'NEW_SERVICE.ASSIGN_STATUS' | translate}}</option>
                <option [id]="'new_service_assign-status-' + (i + 1)"
                    *ngFor="let s of assignStatusOptions; let i = index" [ngValue]="s.value">
                    {{ s.displayValue | translate }}
                </option>
            </select>
        </div>

        <div *ngIf="selectedFilters.length > 0">
            <app-filter-checklist [filters]="selectedFilters" [useApply]="true"
                (resetFilterEmitter)="resetFilter()" (removeFilterEmitter)="removeFilter($event)"
                (applyFilterEmitter)="applyFilter()">
            </app-filter-checklist>
        </div>
    </div>

    <div class="table table-overflow">
        <div>
            <table class="table">
                <thead class="table-light">
                    <tr>
                        <th>{{'COMMON.TABLE_HEADERS.APP_NUM' | translate}}</th>
                        <th>{{'METER_REQUEST.SERVICE_ORDER_ID' | translate}}</th>
                        <th>{{'NEW_SERVICE.MAP_ID' | translate}}</th>
                        <th>{{'COMMON.CUSTOMER.ACCOUNT_NUMBER' | translate}}</th>
                        <th>{{'COMMON.CONTRACT_NUMBER' | translate}}</th>
                        <th>{{'COMMON.TABLE_HEADERS.BUILDING_OWNER' | translate}}</th>
                        <th>{{'COMMON.MBC_DETAILS.CUSTOMER_NAME' | translate}}</th>
                        <th>{{'COMMON.MBC_DETAILS.PHONE_NO' | translate}}</th>
                        <th>{{'COMMON.MBC_DETAILS.EMAIL' | translate}}</th>
                        <th>{{'COMMON.BU.SINGLE' | translate}}</th>
                        <th>{{'COMMON.UT.SINGLE' | translate}}</th>
                        <th>{{'NEW_SERVICE.FEEDER_BAND' | translate}}</th>
                        <th>{{'NEW_SERVICE.FEEDER_NAME' | translate}}</th>
                        <th>{{'NEW_SERVICE.DT_NAME' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.UPRISER_NAME' | translate}}</th>
                        <th class="text-nowrap">{{'COMMON.MBC_DETAILS.METER_NO' | translate}}</th>
                        <th class="text-nowrap">{{'COMMON.MBC_DETAILS.OLD_METER_NO' | translate}}</th>
                        <th class="text-nowrap">{{'COMMON.MBC_DETAILS.INSTALLATION_DATE' | translate}}</th>
                        <th>{{'NEW_SERVICE.SIM_NUMBER' | translate}}</th>
                        <th>{{'COMMON.ADDRESS' | translate}}</th>
                        <th>{{'NEW_SERVICE.SERVICE_TYPE' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.SERVICE_REQUEST_TYPE' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.PROJECT_STATUS' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.PROJECT_DESIGNATION' | translate}}</th>
                        <th>{{'COMMON.MBC_DETAILS.METER_TYPE.SINGLE' | translate}}</th>
                        <th>{{'COMMON.TAG.TITLE' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.USE_OF_PREMISE' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.TYPE_OF_CONNECTION' | translate}}</th>
                        <th class="text-nowrap">{{'COMMON.MBC_DETAILS.RECOMMENDED_TARIFF' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.RECOMMENDED_METER_TYPE' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.NEW_CONN_STATUS' | translate}}</th>
                        <th class="text-nowrap">{{'USER_ACTIVITY.SERVICE_REQUEST_REVIEWED_BY' | translate}}</th>
                        <th class="text-nowrap">{{'USER_ACTIVITY.SERVICE_REQUEST_REVIEW_DATE' | translate}}</th>
                        <th class="text-nowrap">{{'USER_ACTIVITY.SITE_VERIFICATION_STATUS' | translate}}</th>
                        <th class="text-nowrap">{{'USER_ACTIVITY.SITE_VERIFICATION_CAPTURED_BY' | translate}}</th>
                        <th class="text-nowrap">{{'USER_ACTIVITY.SITE_VERIFICATION_DATE' | translate}}</th>
                        <th class="text-nowrap">{{'USER_ACTIVITY.SITE_VERIFICATION_REVIEWED_BY' | translate}}</th>
                        <th class="text-nowrap">{{'USER_ACTIVITY.SITE_VERIFICATION_REVIEW_DATE' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.ACCOUNT_CREATED_BY' | translate}}</th>
                        <th class="text-nowrap">{{'USER_ACTIVITY.APPLICATION_STAGE' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.APPLICATION_DATE' | translate}}</th>
                        <th class="text-nowrap">{{'NEW_SERVICE.ASSIGNED_VENDOR' | translate}}</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let item of items; let i = index" (click)="selectRequestTracker(item.id)">
                        <td>{{ item.applicationNumber | hasValue }}</td>
                        <td>{{ item.serviceOrderId | hasValue }}</td>
                        <td>{{ item.mapId | hasValue }}</td>
                        <td>{{ item.accountNumber | hasValue }}</td>
                        <td>{{ item.spn | hasValue }}</td>
                        <td>{{ item.buildingOwner | hasValue }}</td>
                        <td>{{ item.customerName | hasValue }}</td>
                        <td>{{ item.phoneNumber | hasValue }}</td>
                        <td>{{ item.emailAddress | hasValue }}</td>
                        <td>{{ (hasCimDataIntegration ? item.geographicalRegion : item.region) | hasValue }}</td>
                        <td>{{ (hasCimDataIntegration ? item.subGeographicalRegion : item.area) | hasValue }}</td>
                        <td>{{ (hasCimDataIntegration ? item.acLineBand : item.feederBand) | hasValue }}</td>
                        <td>{{ (hasCimDataIntegration ? item.acLineName : item.feederName) | hasValue }}</td>
                        <td>{{ (hasCimDataIntegration ? item.substationName : item.dtName) | hasValue }}</td>
                        <td>{{ item.upriserName | hasValue }}</td>
                        <td>{{ item.meterNumber | hasValue }}</td>
                        <td>{{ item.oldMeterNumber | hasValue }}</td>
                        <td>{{ item.installationDate | hasValue }}</td>
                        <td>{{ item.simNo | hasValue }}</td>
                        <td>{{ item.address | hasValue }}</td>
                        <td>{{ item.sltStatus | hasValue }}</td>
                        <td>{{ item.subserviceType | hasValue }}</td>
                        <td>{{ item.projectStatus | hasValue }}</td>
                        <td>{{ item.projectDesignation | hasValue }}</td>
                        <td>{{ item.meterType | hasValue }}</td>
                        <td>
                            <div class="building-status" [ngClass]="{
                                'orange-status v-2': item.tag == 'New Customer',
                                'green-status v-2': item.tag == 'Existing'
                            }">
                                {{ item.tag | hasValue }}
                            </div>
                        </td>
                        <td>{{ item.useOfPremise | hasValue }}</td>
                        <td>{{ item.typeOfConnection | hasValue }}</td>
                        <td>{{ item.recommendedTariff | hasValue }}</td>
                        <td>{{ item.recommendedMeterType | hasValue }}</td>
                        <td>
                            <div *ngIf="item.kycStatus === 'Pending'" class="gray-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.PENDING' | translate}}
                            </div>
                            <div *ngIf="item.kycStatus === 'Rejected'" class="dark-red-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.REJECTED' | translate}}
                            </div>
                            <div *ngIf="item.kycStatus === 'InProgress'" class="orange-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.INPROGRESS' | translate}}
                            </div>
                            <div *ngIf="item.kycStatus === 'Complete'" class="green-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.APPROVED' | translate}}
                            </div>
                            <div *ngIf="item.kycStatus === 'Suspended'" class="orange-status v-2">
                                {{'COMMON.KYC_STATUS_OPTIONS.SUSPENDED' | translate}}
                            </div>
                        </td>
                        <td>{{ item.serviceRequestReviewedBy | hasValue }}</td>
                        <td>{{ item.serviceRequestReviewDate | hasValue }}</td>
                        <td>
                            <div
                                class="building-status"
                                [ngClass]="{ 'assigned-building': item.siteVerificationStatus == 'Assigned',
                                    'rejected-building': item.siteVerificationStatus == 'Rejected',
                                    'approved-building': item.siteVerificationStatus == 'Approved',
                                    'unvalidated-building': item.siteVerificationStatus == 'New',
                                    'submitted-building': item.siteVerificationStatus == 'Submitted',
                                    'suspended-building': item.siteVerificationStatus == 'Suspended'
                                }"
                            >
                                {{ item.siteVerificationStatus | hasValue }}
                            </div>
                        </td>
                        <td>{{ item.siteVerificationCapturedBy | hasValue }}</td>
                        <td>{{ item.siteVerificationDate | hasValue }}</td>
                        <td>{{ item.siteVerificationReviewedBy | hasValue }}</td>
                        <td>{{ item.siteVerificationReviewDate | hasValue }}</td>
                        <td>{{ item.accountCreatedBy | hasValue }}</td>
                        <td>{{ item.applicationStage | hasValue }}</td>
                        <td>{{ item.applicationDate | hasValue }}</td>
                        <td>{{ item.assignedVendor | hasValue }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>

    <div>
        <app-paging *ngIf="count > 0" [pageSize]="pageSize" [useDirect]="true" [count]="count"
            [currentPage]="currentPage" (pageChange)="pageChange($event)"></app-paging>
    </div>
</div>
